import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useEmployeeFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {

        userData, userDataLoading,
        department, departmentLoading,
        currentApprovers,

    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
    const [isFilterDirty, setIsFilterDirty] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
    {
        key: "company_user",
        label: "User",
        value: searchParams.get("company_user") || ""
    },
    {
        key: "approval_status",
        label: "Status",
        value: searchParams.get("approval_status") || ""
    },
    {
        key: "leave_type",
        label: "Leave type",
        value: searchParams.get("leave_type") || ""
    },
    {
        key: "department",
        label: "",
        value: searchParams.get("department") || ""
    },
    {
        key: "cost_center",
        label: toTitleCase(searchParams.get("cost_center") || ""),
        value: searchParams.get("cost_center") || ""
    },
    {
        key: "current_approver",
        label: "",
        value: searchParams.get("current_approver") || ""
    }

  ]);

  useEffect(()=>{

    if(!userDataLoading ){
        let gender = searchParams.get("gender") || ""

        let selectedUserData = [...userData].find(item=>item.id == searchParams.get("userData") || "")
        let selectedCostCenter = searchParams.get("cost_center") || ""
        let selectedDepartment = [...department].find(item=>item.id == searchParams.get("department") || "")
        let selectedCurrentApprover = [...(currentApprovers || [])].find(item=>item.id == searchParams.get("current_approver"))


        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "approval_status",
                label: "Approval status",
                value: searchParams.get("approval_status") || ""
            },
            {
                key: "leave_type",
                label: "Leave type",
                value: searchParams.get("leave_type") || ""
            },
           
            {
                key: "company_user",
                 label: selectedUserData?.first_name+" "+selectedUserData?.last_name,
                value: searchParams.get("company_user") || ""
            },
            {
                key: "department",
                label: selectedDepartment?.name,
                value: searchParams.get("department") || ""
            },{
                key: "cost_center",
                label: toTitleCase(selectedCostCenter),
                value: selectedCostCenter
            },
            {
                key: "current_approver",
                label: selectedCurrentApprover?.name || "",
                value: searchParams.get("current_approver") || ""
            }

          ]
          setFilters(_filters)

    }

 
  },[
    userData
  ])

  const handleFilterChange =  (data, key, make_call=false) => {

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)

    if(!selectedFilter){
        // key not present in the current filters array (e.g. rebuilt without it)
        _filters.push({ key, label: "", value: "" })
        selectedFilter = _filters[_filters.length - 1]
    }

    if(Array.isArray(data)){
        // selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data

    }else{
        selectedFilter['label'] = data?.label || ""
        selectedFilter['value'] = data?.value || ""
    }


    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }


  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {

    console.log("---filterssss--->>>>", [...filters])
    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }

  // Clear All only resets the draft fields inside the drawer - it must
  // NOT trigger a search. The actual API call happens when the user
  // clicks Apply Filter.
  const handleClearAll = () => {
    const hadValues = filters.some(filter => filter.key !== "search" && (Array.isArray(filter.value) ? filter.value.length > 0 : !!filter.value))
    let clearedFilters = filters.map(filter => ({
      ...filter,
      value: Array.isArray(filter.value) ? [] : "",
      label: filter.key === "search" ? "Search term" : ""
    }))
    setFilters(clearedFilters)
    if(hadValues){
      setIsFilterDirty(true)
    }
  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty, setIsFilterDirty
  };
}
